export function TableFallback({text}) {
  return (
    <p className='min-h-[300px] flex justify-center items-center'>{text}</p>
  )
}